const SKINCOLOR = [
    { value: "Yellow", label: "Amarela" },
    { value: "White", label: "Branca" },
    { value: "Indigenous", label: "Indígena" },
    { value: "Brown", label: "Parda" },
    { value: "Black", label: "Preta" },
    { value: "NotDeclared", label: "Não Declarado" },
];

export default SKINCOLOR